import React from 'react';
import { withRouter } from 'react-router';
import Transitions from './../core/Transitions.js';
import Footer from './Footer.jsx';
import FooterUtil from './../utils/FooterHelper';
import Screen from './../utils/Screen.js';
import OmnitureTracking from '../utils/OmnitureTracking.js';
//Components
var NavigationBar = require('./NavigationBar');
var ProductHeader = require('./Common/ProductHeader');
var ErrorList = require('./Common/ErrorList.jsx');
var ErrorBar = require('./Common/ErrorBar.jsx');
var AccountTypeSection = require('./AccountType/AccountTypeSection.jsx');
var YourDetailsSection = require('./YourDetails/YourDetailsSection.jsx');
var InvestmentAllocationSection = require('./InvestmentAllocation/InvestmentAllocationSection');
var SuperFirstTransferSection = require('./SuperFirstTransfer/SuperFirstTransferSection.jsx');
var AutoRebalancingSection = require('./AutoRebalancing/AutoRebalancingSection.jsx');
var AdviserFee = require('./AdviserFee/AdviceFeeSection.jsx');
var OnlineAccessSection = require('./OnlineAccess/OnlineAccessSection.jsx');
var PortfolioRebateSection = require('./PortfolioRebate/PortfolioRebateSection.jsx');
var FundingYourSuperPensionSection = require('./FundingYourProduct/FundingYourSuperPensionSection.jsx');
var RegularInvestmentPlanSection = require('./RegularInvestmentPlan/RegularInvestmentPlanSection.jsx');
var FundingYourInvestmentSection = require('./FundingYourProduct/FundingYourInvestmentSection.jsx');
var InSpecieTransferSection = require('./InSpecieTransfer/InSpecieTransferSection.jsx');
var AccountSettingsSection = require('./AccountSettings/AccountSettingsSection.jsx').default;
var SpecialRequestsSection = require('./SpecialRequests/SpecialRequestsSection.jsx').default;
var AdviserAuthoritySection = require('./AdviserAuthority/AdviserAuthoritySection.jsx');
var AdviserAttestationSection = require('./AdviserAttestation/AdviserAttestationSection.jsx');
var PensionPaymentSection = require('./PensionPayment/PensionPaymentSection.jsx').default;
var BeneficiaryDetailsSection = require('./BeneficiaryDetails/BeneficiaryDetailsSection.jsx');
var PensionTypeSection = require('./PensionType/PensionTypeSection.jsx').default;
var IncomeDistributionSection = require('./IncomeDistribution/IncomeDistributionSection.jsx').default;
var UserNotification = require('./Common/UserNotification.jsx');

//Actions
var ApplicationActions = require('../actions/ApplicationActions');
var Products = require('../utils/Products.js');
var ApplicationStore = require('../stores/ApplicationStore');
var ContentService = require('../services/ContentService');
var SectionId = require('../constants/ApplicationConstants').SectionId;
var ClientIdentificationModes = require('../constants/ApplicationConstants').ClientIdentificationModes;

//Helpers
var DownloadFormsHelper = require('../utils/DownloadFormsHelper.js').default;

function GetApplicationState() {
    return {
        productId: ApplicationStore.getProductId(),
        hideErrorBar: ApplicationStore.hideErrorBar(),
        sectionVisibility: ApplicationStore.getSectionVisibility(),
        errorList: ApplicationStore.errorList(),
        fieldWithErrorId: ApplicationStore.getFieldWithErrorId(),
        product: ApplicationStore.getProduct(),
        formModel: ApplicationStore.getFormModel(),
        consolidatedFormModel: ApplicationStore.getConsolidatedFormModel(),
        userType: ApplicationStore.getUserType(),
        accountType: ApplicationStore.getAccountType(),
        content: ContentService.getContent(),
        canSaveApplication: ApplicationStore.getCanSaveApplication(),
        isSaveDisabled: ApplicationStore.getIsSaveDisabled(),
        canReviewApplication: ApplicationStore.getCanReviewApplication(),
        clientOin: ApplicationStore.getClientOin(),
        showMoreMenu: ApplicationStore.getShowHideMore(),
        sectionId: ApplicationStore.getSectionId(),
        kycFlag: ApplicationStore.getKYCFlag(),
        showDownloadMenu: ApplicationStore.getShowDownloadMenu(),
        formsToDownload: ApplicationStore.getFormsToDownload(),
        enableDownloadButton: ApplicationStore.getEnableDownloadButton(),
        downloadInProgress: ApplicationStore.getDownloadInProgress(),
        readyForDownload: ApplicationStore.getReadyForDownload(),
        selectedForms: ApplicationStore.getSelectedForms(),
        downloadedForms: ApplicationStore.getDownloadedForms(),
        formDownloaded: ApplicationStore.getIsFormsDownloaded(),
        downloadFormsFailed: ApplicationStore.getDownloadFormsFailed(),
        showShellAccountNotification: ApplicationStore.getShowShellAccountNotification(),
        clientIdentificationMode: ApplicationStore.getClientIdentificationMode(),
        clientIdentificationModeQueryInfo: ApplicationStore.getClientIdentificationModeQueryInfo()
    };
}

// var _dockFooterStyle;

var ApplicationForm = React.createClass({

    getInitialState: function () {
        return GetApplicationState();
    },

    componentDidMount: function () {
        ApplicationStore.addChangeListener(this._onChange);
        ApplicationActions.getDownsizerContributionKillSwitch();
        this.displayCorrectlyOnNonSelection();
        OmnitureTracking.getTrackingEnabled();
    },
    componentWillUnmount: function () {
        ApplicationStore.removeChangeListener(this._onChange);
    },
    _onChange: function () {
        this.setState(GetApplicationState());
    },

    componentWillUpdate: function (nextProps, nextState) {
        if (nextState.canReviewApplication === true || nextState.clientIdentificationMode.isReady) {
            //do review action
            if (nextState.canReviewApplication === true) {
                ApplicationActions.reviewApplication({
                    formModel: nextState.formModel,
                    consolidatedFormModel: nextState.consolidatedFormModel,
                    sectionVisibility: this.state.sectionVisibility,
                    product: this.state.product
                });
            }
            if (nextState.clientIdentificationMode.isReady) {
                if (nextState.clientIdentificationMode.identificationMode === ClientIdentificationModes.E_FORM) {
                    Transitions.forwardfromApplicationForm(this.props.router, {identificationMode : ClientIdentificationModes.E_FORM});
                } else {
                    Transitions.forwardfromApplicationForm(this.props.router);
                }
            }
            else {
                if(Products.isAnnuity(this.state.product.value)) {
                    Transitions.forwardfromApplicationForm(this.props.router);
                } else {
                    this.detectIdentificationMode(nextState.clientIdentificationModeQueryInfo);
                }
            }
        }
    },
    componentDidUpdate: function () {
        if (this.state.errorList && (this.state.errorList.length > 0)) {
            this.scrollUpdate();
        }

        this.displayCorrectlyOnSelection();
    },
    
    detectIdentificationMode: function(queryInfo) {
        ApplicationActions.getClientIdentificationMode(queryInfo);
    },
    scrollUpdate: function () {
        let timeOut;

        if (this.state.isForReview) {
            window.requestAnimationFrame(() => {
                timeOut = setTimeout(() => {
                    let footer = document.getElementsByClassName('footer')[0];
                    if (footer) {
                        footer.scrollIntoView();
                        let margin = footer.offsetHeight;
                        const scrollYPosition = Screen.getScrollYPosition();
                        window.scrollTo(0, scrollYPosition - margin);
                        this.setState({ isForReview: false });
                    }
                }, 250);
            });
        }

        if (!this.state.isForReview && timeOut) {
            clearTimeout(timeOut);
        }
    },

    _review: function (withShellAccount) {
        ApplicationActions.requestApplicationReview(withShellAccount);
        ApplicationActions.validateApplication(this.state.productId, this.state.accountType);
        ApplicationActions.setAssetAllocations(this.state.productId);
        this.setState({ isForReview: true });
    },
    toggleUserNotification: function () {
        ApplicationActions.toggleShellAccountNotification();
    },
    displayCorrectlyOnNonSelection: function() {
        if (Products.isAnnuity(this.state.productId) && (!this.state.accountType || this.state.accountType === ''))  {
            var divAfterProductHeader = document.querySelectorAll('#ProductHeader + div');

            if (divAfterProductHeader && divAfterProductHeader.length > 0) {
                var divApplicationForm = document.querySelectorAll('#ApplicationForm');
                var divProductHeader = document.querySelectorAll('#ProductHeader');
                var divNavigationBar = document.querySelectorAll('#NavigationBar');
                var btnReviewAndConfirm = document.querySelectorAll('#review-and-confirm');

                if (divApplicationForm && divProductHeader && divNavigationBar && btnReviewAndConfirm) {
                    var marginOfError = 17; // margin of error, to make sure that the scrollbar does not appear on the right
                    var computedHeight = divApplicationForm[0].clientHeight - divProductHeader[0].clientHeight - divNavigationBar[0].clientHeight - btnReviewAndConfirm[0].clientHeight - marginOfError;
                    divAfterProductHeader[0].style.height = computedHeight + 'px';
                }
            }
        }
    },
    displayCorrectlyOnSelection: function() {
        if (Products.isAnnuity(this.state.productId) && (this.state.accountType && this.state.accountType !== '')) {
            var divAfterProductHeader = document.querySelectorAll('#ProductHeader + div');
            if (divAfterProductHeader && divAfterProductHeader.length > 0) {
                divAfterProductHeader[0].style.height = '';
            }
        }
    },
    onReview: function(event) {
        event.preventDefault();
        this._review(false);
    },
    onContinue: function() {
        this._review(true);
    },
    render: function () {
        // FIXME: Don't need to pass through the entire content object for every component (potential for memory leak)
        var AccountType = (this.state.sectionVisibility.accountType) ? <AccountTypeSection content={this.state.content} focus={this.state.sectionId === SectionId.accountType} /> : null;
        var YourDetails = (this.state.sectionVisibility.yourDetails) ? <YourDetailsSection productId={this.state.productId} accountType={this.state.accountType} content={this.state.content} focus={this.state.sectionId === SectionId.yourDetails} /> : null;
        var AutoRebalancing = (this.state.sectionVisibility.autoRebalancing) ? <AutoRebalancingSection productId={this.state.productId} content={this.state.content} focus={this.state.sectionId === SectionId.autoRebalancing} /> : null;
        var OnlineAccess = (this.state.sectionVisibility.onlineAccess) ? <OnlineAccessSection content={this.state.content} productId={this.state.productId} userType={this.state.userType} focus={this.state.sectionId === SectionId.onlineAccess} /> : null;
        var AdviceFee = (this.state.sectionVisibility.adviserFee) ? <AdviserFee hideAdviserFee={this.state.sectionVisibility.adviserFee} productId={this.state.productId} content={this.state.content} focus={this.state.sectionId === SectionId.adviserFee} /> : null;
        var PortfolioRebate = (this.state.sectionVisibility.portfolioRebate) ? <PortfolioRebateSection product={this.state.product} accountType={this.state.accountType} content={this.state.content} focus={this.state.sectionId === SectionId.portfolioRebate} /> : null;
        var FundingYourProduct;
        if (this.state.sectionVisibility.fundingYourProduct) {
            if (Products.isInvestment(this.state.productId)) {
                FundingYourProduct = <FundingYourInvestmentSection focus={this.state.sectionId === SectionId.fundingYourProduct} productId={this.state.productId} content={this.state.content } />;
            } else {
                FundingYourProduct = <FundingYourSuperPensionSection focus={this.state.sectionId === SectionId.fundingYourProduct} productId={this.state.productId} content={this.state.content } />;
            }
        }
        var InSpecieTransfer = (this.state.sectionVisibility.inSpecieTransfer) ? <InSpecieTransferSection focus={this.state.sectionId === SectionId.inSpecieTransfer} content={this.state.content} productId={this.state.productId} /> : null;
        var SuperFirstTransfer = (this.state.sectionVisibility.superFirstTransfer) ? <SuperFirstTransferSection focus={this.state.sectionId === SectionId.superFirstTransfer} content={this.state.content} /> : null;
        var RegularInvestmentPlan = (this.state.sectionVisibility.regularInvestmentPlan) ? <RegularInvestmentPlanSection focus={this.state.sectionId === SectionId.regularInvestmentPlan} content={this.state.content} productId={this.state.productId} userType={this.state.userType} accountType={this.state.accountType }/> : null;
        var AccountSettings = (this.state.sectionVisibility.accountSettings) ? <AccountSettingsSection focus={this.state.sectionId === SectionId.accountSettings} content={this.state.content} /> : null;
        var PensionPayment = (this.state.sectionVisibility.pensionPayment) ? <PensionPaymentSection focus={this.state.sectionId === SectionId.pensionPayment} content={this.state.content} productId={this.state.productId} userType={this.state.userType} accountType={this.state.accountType }/> : null;
        var PensionType = (this.state.sectionVisibility.pensionType) ? <PensionTypeSection focus={this.state.sectionId === SectionId.pensionType} content={this.state.content} /> : null;
        var InvestmentAllocation = (this.state.sectionVisibility.investmentAllocation)
            ? <InvestmentAllocationSection focus={this.state.sectionId === SectionId.investmentAllocation} productId={this.state.productId} content={this.state.content}/>
            : null;
        var BeneficiaryDetails = (this.state.sectionVisibility.beneficiaryDetails) ? <BeneficiaryDetailsSection focus={this.state.sectionId === SectionId.beneficiaryDetails} content={this.state.content} productId={this.state.productId} /> : null;
        var SpecialRequests = (this.state.sectionVisibility.specialRequests) ? <SpecialRequestsSection focus={this.state.sectionId === SectionId.specialRequests} /> : null;
        var AdviserAuthority = (this.state.sectionVisibility.adviserAuthority) ? <AdviserAuthoritySection focus={this.state.sectionId === SectionId.adviserAuthority} productId={this.state.productId} userType={this.state.userType} content={this.state.content} /> : null;
        var AdviserAttestation = (this.state.sectionVisibility.adviserAttestation) ? <AdviserAttestationSection focus={this.state.sectionId === SectionId.adviserAttestation} productId={this.state.productId} userType={this.state.userType} content={this.state.content} /> : null;
        var IncomeDistribution = (this.state.sectionVisibility.incomeDistribution) ? <IncomeDistributionSection focus={this.state.sectionId === SectionId.incomeDistribution} content={this.state.content} /> : null;
        const footerContent = FooterUtil.getContent(this.state.productId, this.state.content.footer);
        var dockFooterStyle = FooterUtil.adjustViewport();

        var yourDetailsContent = (this.state.content) ? this.state.content.yourDetails[this.state.product.value] : {};

        var ShellAccountUserNotification = <UserNotification id="shellAccountNotification"
            className="top-sticky-user-notification"
            message={this.state.content.shellAccountNotification}
            onClick={this.toggleUserNotification}
            isHidden={!this.state.showShellAccountNotification}
            showButton={true} buttonText="Continue" onClickButton={this.onContinue}/>;

        var downloadData = DownloadFormsHelper.createDownloadData(this.state);

        return (
            <div id="ApplicationForm">
                <div className="mainContent" style={dockFooterStyle}>
                    <NavigationBar product={this.state.product}
                        route={this.props.route.path}
                        moreMenuContent={this.state.content.moreMenu}
                        showMoreMenu={this.state.showMoreMenu}
                        application={this.state.formModel}
                        clientIdentificationMode={this.state.clientIdentificationMode}
                        isSaveDisabled={this.state.isSaveDisabled}
                        canSaveApplication={this.state.canSaveApplication}
                        showDownloadMenu={this.state.showDownloadMenu}
                        accountType={this.state.accountType}
                        download={downloadData}/>
                    <ErrorBar hideErrorBar={this.state.hideErrorBar}
                        errorList={this.state.errorList}
                        fieldWithErrorId={this.state.fieldWithErrorId} />
                    <ProductHeader product={this.state.product} content={yourDetailsContent} />
                    {AccountType}
                    {YourDetails}
                    {AccountSettings}
                    {PensionType}
                    {FundingYourProduct}
                    {InSpecieTransfer}
                    {SuperFirstTransfer}
                    {InvestmentAllocation}
                    {PensionPayment}
                    {BeneficiaryDetails}
                    {RegularInvestmentPlan}
                    {IncomeDistribution}
                    {AutoRebalancing}
                    {PortfolioRebate}
                    {AdviceFee}
                    {AdviserAuthority}
                    {AdviserAttestation}
                    {OnlineAccess}
                    {SpecialRequests}
                    <ErrorList hideErrorBar={this.state.hideErrorBar} errorList={this.state.errorList} />
                    {ShellAccountUserNotification}
                    <button className="btn navbar navbar-success navigationBar" id="review-and-confirm" onClick={this.onReview}>
                        <div className="container investment-option-save-bar">
                            <div className="pull-left"><h3>Continue</h3></div>
                            <div className="pull-right"><a className="arrow"><i className="icon icon-right-open-big"></i></a></div>
                        </div>
                    </button>
                </div>
                <Footer content={footerContent} />
            </div>
        );
    }
});

module.exports = withRouter(ApplicationForm);



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ApplicationForm.jsx